import React, { useEffect, createElement } from 'react';
import { Helmet } from 'react-helmet';
const GoogleTag = () => {
  // Add noscript tag right after body opening
  useEffect(() => {
    // Create the noscript iframe element
    const noscriptIframe = document.createElement('noscript');
    const iframe = document.createElement('iframe');
    iframe.src = 'https://www.googletagmanager.com/ns.html?id=GTM-K8SVZR3T';
    iframe.height = '0';
    iframe.width = '0';
    iframe.style.display = 'none';
    iframe.style.visibility = 'hidden';
    noscriptIframe.appendChild(iframe);
    // Insert at the beginning of the body
    if (document.body.firstChild) {
      document.body.insertBefore(noscriptIframe, document.body.firstChild);
    } else {
      document.body.appendChild(noscriptIframe);
    }
  }, []);
  return <Helmet data-id="element-1701">
      {/* Google Tag Manager */}
      <script data-id="element-1702">
        {`(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
        new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
        j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
        'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
        })(window,document,'script','dataLayer','GTM-K8SVZR3T');`}
      </script>
      {/* End Google Tag Manager */}
      {/* Google tag (gtag.js) */}
      <script async src="https://www.googletagmanager.com/gtag/js?id=AW-17487740465" data-id="element-1703"></script>
      <script data-id="element-1704">
        {`
          window.dataLayer = window.dataLayer || [];
          function gtag(){dataLayer.push(arguments);}
          gtag('js', new Date());
          gtag('config', 'AW-17487740465');
        `}
      </script>
    </Helmet>;
};
export default GoogleTag;